import { Link } from 'react-router-dom';

import { isPreSale } from 'common/helpers/featureFlags';

const LinkToProfile = (props) => {
  const { clubMembership, clubPackage } = props;
  if (!clubMembership) {
    return null;
  }
  let viewButton = 'View Your Club Membership';
  if (isPreSale()) {
    viewButton = 'View Your Pre-Sale Order';
  }
  if (!clubPackage || clubPackage.itemChoice === 'Set Items') {
    return (
      <div className="c7-checkout-summary__buttons">
        <a
          href={`/profile/club-membership/${clubMembership.id}`}
          className="c7-button"
        >
          {viewButton}
        </a>
      </div>
    );
  }
  return (
    <div className="c7-checkout-summary__buttons">
      <Link
        to={`/profile/club-membership/${clubMembership.id}/shipment`}
        className="c7-button c7-button-button--adjust"
      >
        Adjust Your Shipment
      </Link>
    </div>
  );
};

export default LinkToProfile;
